import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import shadow from '../../styles/shadows';
import * as styles from './VerticalMenu.scss';

var VerticalMenu = /*#__PURE__*/function (_Component) {
  _inherits(VerticalMenu, _Component);

  var _super = _createSuper(VerticalMenu);

  function VerticalMenu() {
    _classCallCheck(this, VerticalMenu);

    return _super.apply(this, arguments);
  }

  _createClass(VerticalMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bgColor = _this$props.bgColor,
          children = _this$props.children,
          width = _this$props.width;
      var inlineStyle = {
        backgroundColor: bgColor,
        flex: "0 0 ".concat(width)
      };
      return /*#__PURE__*/React.createElement("nav", {
        style: _objectSpread(_objectSpread({}, inlineStyle), this.props.style ? this.props.style : {}),
        className: styles.nav
      }, children);
    }
  }]);

  return VerticalMenu;
}(Component);

_defineProperty(VerticalMenu, "defaultProps", {
  addedClass: '',
  width: '70px'
});

_defineProperty(VerticalMenu, "propTypes", {
  bgColor: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired
});

export default VerticalMenu;